import { GetFormCategoriesUseCase, FORM_CATEGORY_REPOSITORY, GET_FORM_CATEGORIES_USE_CASE } from '@module/form';
export var formCategoryUseCaseProviders = [{
  provide: GET_FORM_CATEGORIES_USE_CASE,
  useFactory: function useFactory(formCategoryRepository) {
    return new GetFormCategoriesUseCase(formCategoryRepository);
  },
  inject: [FORM_CATEGORY_REPOSITORY]
}];